import React, { memo, useState, useEffect, useCallback, } from "react";
import { useRecoilState, useRecoilValue } from "recoil";

import { postState } from '../../../store/postState';

import { NewPostForm } from '../form/NewPostForm';
import { PostArchiveInfinitScroll } from './PostArchiveInfinitScroll';

export const EditHospitalSideBar = memo((props) => {
  const { init_hospital, staff_user } = props;
  const [postData, setPostData] = useRecoilState(postState);

  // CSSスタイル
  const frameCss = {
    marginTop: "15px",
    height: "1090px",
    width: "100%",
    overflow: "auto",
    backgroundColor: "#fff",
    border: "1px solid rgba(0,0,0,.125)",
  };
  const noContentCss = {
    width: "100%",
    textAlign: "center",
    padding: "5px 0",
    color: "#999"
  }

  return (
    <>
      <NewPostForm init_hospital={init_hospital} staff_user={staff_user} />
      <div style={frameCss}>
      {postData.length < 1 ?
        <div style={noContentCss}>現在、投稿がありません。</div>
      :
        <PostArchiveInfinitScroll init_hospital={init_hospital} />
      }
      </div>
    </>
  );
});